<template>
    <div class="product-training">

        <div class="expert-div-lead" >
            <div class="expert-responsive-lead">
                <h3><span>EXPERT IN</span><strong>HAND Protection</strong></h3>
                <img src="/images/st-learning/hand-protection/exp-main-hand.png" alt="hand protection">
                <h4>Protective Industrial Products is a global leader in hand protection.</h4>
            </div>

            <div class="expert-div-info" ref="mobileView">

                <img src="/images/st-learning/hand-protection/B51111-BOH-Angle.jpg" alt="boss gloves" align="left" style="width:240px;  height:auto;  margin:0 30px;" /> <!--style="width:318px;  height:629px;  margin:0 30px;"-->

                <h2 style="padding-top:50px;">
                    Global Leader <br />in Hand Protection
                </h2>

                <p>
                    Protective Industrial Products is a global leader in hand protection. Our gloves and sleeves are made using proprietary engineered yarn blends and coatings. The result - hand and arm protection that is innovative and performance driven. Meeting todays tough ANSI and EN standards, we develop and market seamless knit, coated and uncoated, polymer, supported and unsupported as well as cut and sewn gloves in both leather and advanced composite materials.
                </p>
            </div>
            <a href="javascript:void(0);" class="expert-read-info">
                <span @mousedown="showMobile" ref="readMore"><small>READ MORE</small><font-awesome-icon :icon="['fas', 'chevron-down']" /></span>
                <span @mousedown="hideMobile" ref="readLess"><small>CLOSE</small><font-awesome-icon :icon="['fas', 'chevron-up']" /></span>
            </a>
        </div>

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider"/>

        <div class="expert-div">

            <h2 class="none">
                Glove Technologies
            </h2>
            <p class="main">
                All gloves have value based on application, length of use and risk. Thats why selecting the right glove is not as simple as one may think. There are many factors that go into determining the correct product.
            </p>
            <div class="expert-sub-menu" >
                <span class="icon icon-hamburger" @mousedown="burgerClicked"><font-awesome-icon :icon="['fas', 'bars']" /></span>
            </div>

            <div align id="tech-th"  class="expert-sub-menu-dropdown" ref="gloveDropdown">
                <div id="tech-th-seamless" style="border-bottom:solid 3px #cd1b00;" @mouseover="seamlessHover" ref="tech-th-seamless">
                    <img src="/images/st-learning/hand-protection/img-coated-seamless-knit-technology-TH.jpg" width="200" height="80" alt="coated seamless knit glove" />
                    COATED SEAMLESS KNIT
                </div>
                <div id="tech-th-poly" @mouseover="polyHover" ref="tech-th-poly">
                    <img src="/images/st-learning/hand-protection/img-polymer-technology-TH.jpg" width="200" height="80" alt="polymer glove"/>
                    POLYMER
                </div>
                <div id="tech-th-cut" @mouseover="cutHover" ref="tech-th-cut">
                    <img src="/images/st-learning/hand-protection/img-cut-and-sewn-technology-TH.jpg" width="200" height="80" alt="cut and sewn"/>
                    CUT AND SEWN
                </div>

            </div>


            <div id="tech-img">
                <img src="/images/st-learning/hand-protection/img-coated-seamless-knit-technology---en.jpg" alt="coat seamless glove technology" id="tech-img-seamless" ref="tech-img-seamless"/>
                <img src="/images/st-learning/hand-protection/img-polymer-technology---en.jpg" alt="polymer glove technology" id="tech-img-poly" style="display:none;" ref="tech-img-poly"/>
                <img src="/images/st-learning/hand-protection/img-cut-and-sewn-technology---en.jpg" alt="cut and sewn glove technology" id="tech-img-cut" style="display:none;" ref="tech-img-cut"/>
            </div>



            <div id="tech-txt">

                <div id="tech-txt-seamless" ref="tech-txt-seamless">
                    <p>
                        <strong>COATED SEAMLESS KNIT TECHNOLOGY</strong> work gloves are built for superior dexterity, grip and tactile sensitivity. ?>
                    </p>
                    <p>
                        <strong>DESIGN FACTORS:</strong><br />Supported by a liner &bull; Wristlet length and shape &bull; Gauge of knit (weight) &bull; Coating variants - coverage typically ranges from palm &amp; fingers to palm, fingers &amp; knuckles to full hand &bull; Coating textured for enhanced grip
                    </p>
                </div>

                <div id="tech-txt-poly" style="display:none;" ref="tech-txt-poly" >
                    <p>
                        <strong>POLYMER TECHNOLOGY</strong> general use gloves are built for superior liquid and chemical resistance.
                    </p>
                    <p>
                    <strong>DESIGN FACTORS:</strong><br />Supported (liner) for added puncture resistance, durability and comfort &bull; Unsupported (no liner) for dexterity, hygiene and cleanliness &bull; Thickness of polymer alone or polymer/liner &bull; Wrist length and shape &bull; Coating variants range from 3/4 dipped to fully coated &bull; Coating textured for enhanced grip
                    </p>
                </div>

                <div id="tech-txt-cut" style="display:none;" ref="tech-txt-cut">
                    <p>
                        <strong>CUT AND SEWN TECHNOLOGY</strong> includes traditional leather, fabrics and specialty composite gloves.
                    </p>
                    <p>
                        <strong>DESIGN FACTORS:</strong><br />Supported by a liner &bull; Wristlet length and shape &bull; Ergonomic design-contoured to hand shape &bull; Uncoated, coated or reinforced coverage varies greatly &bull; Impact-protective thermoplastic rubber (TPR) pads on the knuckles, fingers and back of hand
                    </p>
                </div>

            </div>


            <p class="expert-link">
                <!-- <a href="https://www.amazon.com/stores/page/446A8CF3-5F34-46A9-A1CE-FD7714A7B14C?ingress=0&visitId=d30cc342-e3fc-4080-9d26-b31726265f6b&ref_=ast_bln">View all Hand Protection products ></a> -->
            </p>

        </div>

        <img src="/images/st-learning/tic-divider-gray.gif" class="expert-divider"/>


        <div class="expert-div">

            <h2 class="none">
                Fiber Basics
            </h2>
            <p class="main">
                Fibers are extruded either in very long, continuous form, called filament or in shorter lengths described as short or long Staple fibers. Filaments are aligned, bundled and twisted to form and filament yarns, while Staple fibers are high-speed twisted to form spun yarns of varying diameters.
            </p>

            <div id="fiber-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/hand-protection/img-fiber-spun.gif" width="276" height="50" alt="staple fibers"/>
                        <p>
                            <strong>STAPLE</strong><br />Short staple fibers are twisted together to form yarns of differing thickness offer loftier feel for better comfort and wicking properties.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/hand-protection/img-fiber-filament.gif" width="276" height="50" alt="filament fibers"/>
                        <p>
                            <strong>FILAMENT</strong><br />Continuous length fibers twisted to form filament yarns that offer higher tenacity.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/hand-protection/img-fiber-gauge.gif" width="276" height="50" alt="guauge example"/>
                        <p>
                            <strong>GAUGE</strong><br />The number of rows of stitches per inch. A higher gauge means less bulk and greater dexterity.
                        </p>
                    </div>
                </VueSlickCarousel>
                <p class="expert-link">
                    <!-- <a href="https://www.amazon.com/stores/page/446A8CF3-5F34-46A9-A1CE-FD7714A7B14C?ingress=0&visitId=d30cc342-e3fc-4080-9d26-b31726265f6b&ref_=ast_bln">View all Hand Protection products ></a> -->
                </p>
            </div>
        </div>

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider"/>

        <div class="expert-div">

            <h2 class="none">Liner Basics</h2>
            <p class="main">
                Advanced polymer fibers are the backbone of high-tech gloves. Used principally as support for gloves and arm sleeves, these fibers can be transformed in to various types and forms.
            </p>

            <div id="liner-list">
                <VueSlickCarousel v-bind="settings">

                    <div class="item">
                        <img src="/images/st-learning/hand-protection/img-liner-hppe.jpg" alt="high performance polyethylene" />
                        <p>
                        <strong>HPPE</strong> <br />
                        <em>
                            High-Performance Polyethylene
                        </em>
                        </p>

                        <p>
                            Products constructed with HPPE fibers are suitable for protection against mechanical hazards in the toughest environments. HPPE fiber products can be designed for different protection levels, up to the highest levels, while maintaining an unprecedented level of comfort. They are also highly resistant to abrasion and chemicals, so you can rely on them to provide long-lasting protection.
                        </p>
                    </div>

                    <div class="item">
                        <img src="/images/st-learning/hand-protection/img-liner-acp.jpg" alt="ACP Technology" />
                        <p>
                        <strong>ACP TECHNOLOGY</strong> <br />
                        <em>Aramid</em>
                        </p>

                        <p>
                            Proprietary ACP Technology raises the standards for performance knit products offering an increase in overall performance and value compared to traditional Para-Aramid products. ACP provides excellent abrasion and cut resistance for lower cost per use. ACP Technology gloves and sleeves are 100% silicone free.
                        </p>
                    </div>

                    <div class="item">
                        <img src="/images/st-learning/hand-protection/img-liner-fabric.jpg" alt="blended yarns" />
                        <p>
                            <strong>BLENDED YARNS</strong> <br />
                            <em>Nylon / Polyester / Cotton / Acrylic</em>
                        </p>

                        <p>
                            Because of technological advancements, the range of gloves on the market today are geared toward task-specific applications — meaning there is a "right" glove for every worker performing a specific task. Today’s consumer wants a glove that offers not only safety, but enhanced dexterity, longevity, comfort and grip.
                        </p>
                    </div>
                </VueSlickCarousel>


            <p class="expert-link">
                <!-- <a href="https://www.amazon.com/stores/page/446A8CF3-5F34-46A9-A1CE-FD7714A7B14C?ingress=0&visitId=d30cc342-e3fc-4080-9d26-b31726265f6b&ref_=ast_bln">View all Hand Protection products ></a> -->
            </p>
            </div>
        </div>

        <img src="/images/st-learning/tic-divider-gray.gif" class="expert-divider"/>


        <div class="expert-div">

            <h2 class="none">Material Basics</h2>
            <p class="main" >
                Materials play a key role in the glove selection process. It is important to understand every facet of the glove materials and design to maximize protection, dexterity and comfort.
            </p>

            <div id="material-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/hand-protection/img-material-syn-leather.jpg" alt="synthetic leather" />
                        <p>
                            <strong>SYNTHETIC LEATHER</strong> <br />
                            Includes materials made from high-tensile resins applied to fabric as well as microfiber fabrics that are similar to natural leather. Soft, durable and tear resistant with high tensile strength.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/hand-protection/img-material-leather.jpg" alt="natural leather"/>
                        <p>
                            <strong>NATURAL LEATHER</strong> <br />Leather can be separated into the upper top grain of highest quality and the bottom split layer, which is thinner and more pliable than top grain.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/hand-protection/img-material-fabric.jpg" alt="fabric"/>
                        <p>
                            <strong>FABRIC</strong> <br />
                            Numerous fabrics—synthetic or natural—are used to produce a multitude of gloves. Thermal layering can provide additional protection from cold or heat. The addition of Spandex allows for enhanced flexibility.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>

            <p class="expert-link">
                <!-- <a href="https://www.amazon.com/stores/page/446A8CF3-5F34-46A9-A1CE-FD7714A7B14C?ingress=0&visitId=d30cc342-e3fc-4080-9d26-b31726265f6b&ref_=ast_bln">View all Hand Protection products ></a> -->
            </p>

        </div>

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider"/>

        <div class="expert-div">

            <h2 class="none">Coating Basics</h2>
            <p class="main">
                Coatings are used to enhance the glove's grip and improve resistance to snags, abrasion, punctures, tears and offer liquid or contamination protection.
            </p>

            <div id="coating-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/hand-protection/img-coating-nitrile.jpg" width="276" height="42" alt="nitrile coating"/>
                        <p>
                        <strong>NITRILE</strong> <br />
                        Excellent dry grip, thicker coating offers superior resistance to snag, cut, puncture and abrasion. When enhanced by a foam coating, it offers very good grip in chemicals including oils, petrochemicals, fuels and most acids.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/hand-protection/img-coating-latex.jpg" width="276" height="42" alt="latex coating"/>
                        <p>
                        <strong>LATEX</strong><br />Offers good dry and wet (aqueous-based liquids, animal fats, caustics, acids and alcohols) grip as well as resistance to snag, cut, puncture and abrasion.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/hand-protection/img-coating-neoprene.jpg" width="276" height="42" alt="neoprene coating"/>
                        <p>
                        <strong>NEOPRENE</strong><br />Offers good dry and wet (heavy oils, acids, caustics, grease and solvents) grip as well as excellent resistance to snag, cut, puncture and abrasion.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/hand-protection/img-coating-poly.jpg" width="276" height="42" alt="polyurethane coating"/>
                        <p>
                            <strong>POLYURETHANE (PU)</strong><br />
                            Offers good abrasion resistance and dry grip, and fair grip in slightly wet conditions. PU properties allow for a very thin coating, which results in excellent tactility and dexterity.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/hand-protection/img-coating-pvc.jpg" width="276" height="42" alt="pvc coating"/>
                        <p>
                        <strong>POLYVINYL CHLORIDE (PVC)</strong><br />
                        Durable resistance and barrier protection against petrochemicals, oils and grease. While it is flexible, PVC does not provide the tactile sensitivity associated with most rubber products.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>

            <p class="expert-link">
                <!-- <a href="https://www.amazon.com/stores/page/446A8CF3-5F34-46A9-A1CE-FD7714A7B14C?ingress=0&visitId=d30cc342-e3fc-4080-9d26-b31726265f6b&ref_=ast_bln">View all Hand Protection products ></a> -->
            </p>

        </div>

        <img src="/images/st-learning/tic-divider-gray.gif" class="expert-divider"/>

        <div class="expert-div">

            <h2 class="none">Grip Basics</h2>
            <p class="main">
                Coatings are used to enhance the glove's grip and improve resistance to snags, abrasion, punctures, tears and offer liquid or contamination protection.
            </p>

            <div id="grip-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/hand-protection/img-grip-smooth.jpg" width="276" height="42" alt="smooth grip coating" />
                        <p>
                        <strong>SMOOTH</strong> <br />
                        Available in a variety of polymers such as latex, nitrile, PVC, Neoprene and Polyurethane. Smooth coatings provide the wearer an excellent dry grip. Liquids will not absorb into the coating which will keep the hands dry.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/hand-protection/img-grip-microsurface.jpg" width="276" height="42" alt="microfinish grip coating" />
                        <p>
                        <strong>MICROFINISH / MICROSURFACE</strong> <br />
                        Created by using a soft and flexible compound such as latex or nitrile filled with thousands of tiny suction cups. As these suction cups come into contact with a surface, they create a vacuum that disperses fluids away from the object to allow clean contact with the object. Works well in handling wet and dirty applications.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/hand-protection/img-grip-foam.jpg" width="276" height="42" alt="foam/microfoam grip coating" />
                        <p>
                        <strong>FOAM / MICROFOAM</strong> <br />
                        Available in Nitrile, Latex and PVC, the coating is designed to channel away liquids to allow better handling in wet and dirty conditions.  Also provides excellent grip and tactile sensitivity in dry applications.
                        </p>
                    </div>


                    <div>
                        <img src="/images/st-learning/hand-protection/img-grip-pattern.jpg" width="276" height="42" alt="pattern grip coating" />
                        <p>
                        <strong>PATTERN</strong> <br />
                        Patterns such as dots, blocks and palm coatings in a variety of polymers provide an enhanced grip, performance and durability. String knit/ambidextrous gloves can have a pattern screened on both sides to extend the life of the glove.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/hand-protection/img-grip-crinkle.jpg" width="276" height="42" alt="crinkle grip coating" />
                        <p>
                        <strong>CRINKLE</strong> <br />
                        Latex crinkle coatings are designed to channel away liquids to allow a better handling in heavy duty wet and dirty conditions.  The thicker coating provides additional protection for cut and puncture applications.
                        </p>
                    </div>


                    <div>
                        <img src="/images/st-learning/hand-protection/img-grip-rough.jpg" width="276" height="42" alt="rough grip coating"/>
                        <p>
                        <strong>ROUGH</strong> <br />
                        Rough finishes provide an economical choice of enhancing abrasion and cut protection while providing good protection in wet and dry applications.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/hand-protection/img-grip-sandy.jpg" width="276" height="42" alt="sandy grip coating" />
                        <p>
                        <strong>SANDY</strong> <br />
                        Premium Sandy finishes enhance abrasion and cut protection while providing excellent protection in wet and rugged applications.
                        </p>
                    </div>


                    <div>
                        <img src="/images/st-learning/hand-protection/img-grip-raised-diamond.jpg" width="276" height="42" alt="raised diamond grip coating" />
                        <p>
                        <strong>RAISED DIAMOND</strong> <br />
                        Diamond patterns are commonly used on unsupported products which provide added grip on wet or dry surfaces. Diamond patterns are more commonly used in food handling and processing applications.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/hand-protection/img-grip-honeycomb.jpg" width="276" height="42" alt="honeycomb grip coating" />
                        <p>
                        <strong>HONEYCOMB</strong> <br />
                        Honeycomb patterns are commonly used on unsupported products which provide added grip on wet or dry surfaces.  Honeycomb patterns are more commonly used in janitorial, sanitation and general maintenance applications.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>

            <p class="expert-link">
                <!-- <a href="https://www.amazon.com/stores/page/446A8CF3-5F34-46A9-A1CE-FD7714A7B14C?ingress=0&visitId=d30cc342-e3fc-4080-9d26-b31726265f6b&ref_=ast_bln">View all Hand Protection products ></a> -->
            </p>

        </div>

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider"/>

        <div class="expert-div"  style="border-bottom:none;">

            <h2 class="none">
                Cut Basics
            </h2>
            <p class="main">The following Cut Score Application details correlate ANSI cut scores to their relevant applications.</p>

            <div id="cut-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <div>
                        <img src="/images/st-learning/hand-protection/A1.png" alt="smooth grip coating" />
                        </div>
                        <p>
                        <strong>200 – 499 GRAMS: TYPICAL USES
                        </strong> <br />
                        Light to Medium-duty Assembly, Maintenance & Repair, Material Handling and Warehouse Shipping and Receiving.
                        </p>
                    </div>

                    <div>
                        <div>
                        <img src="/images/st-learning/hand-protection/A2.png" alt="microfinish grip coating" />
                        </div>
                        <p>
                        <strong>500 – 999 GRAMS: TYPICAL USES</strong> <br />
                        Light to Medium-duty Assembly, Automotive, Construction, Maintenance & Repair, Material Handling and Metal Handling.
                        </p>
                    </div>

                    <div>
                        <div>
                        <img src="/images/st-learning/hand-protection/A3.png" alt="foam/microfoam grip coating" />
                        </div>
                        <p>
                        <strong>1,000 – 1,499 GRAMS: TYPICAL USES</strong> <br />
                        Medium to Heavy-duty Assembly, Automotive, Construction, Maintenance & Repair, Material Handling and Metal Handling.
                        </p>
                    </div>


                    <div>
                        <div>
                        <img src="/images/st-learning/hand-protection/A4.png" alt="pattern grip coating" />
                        </div>
                        <p>
                        <strong>1,500 – 2,199 GRAMS: TYPICAL USES</strong> <br />
                        Medium-duty Assembly, Automotive, Construction, Glass Fixture Installation, Material Handling and Metal Handling.
                        </p>
                    </div>

                    <div>
                        <div>
                        <img src="/images/st-learning/hand-protection/A5.png"  alt="crinkle grip coating" />
                        </div>
                        <p>
                        <strong>2,200 – 2,999 GRAMS: TYPICAL USES</strong> <br />
                        Heavy-duty Assembly, Automotive, Construction, Glass Handling, Material Handling, Metal Handling and Metal Stamping.
                        </p>
                    </div>


                    <div>
                        <div>
                        <img src="/images/st-learning/hand-protection/A6.png" alt="rough grip coating"/>
                        </div>
                        <p>
                        <strong>3,000 – 3,999 GRAMS: TYPICAL USES</strong> <br />
                        Heavy-duty Assembly, Automotive, Construction, Glass Handling, Material Handling, Metal Handling and Metal Stamping.
                        </p>
                    </div>

                    <div>
                        <div>
                        <img src="/images/st-learning/hand-protection/A7.png" alt="sandy grip coating" />
                        </div>

                        <p>
                        <strong>4,000 – 4,999 GRAMS: TYPICAL USES </strong> <br />
                        Heavy-duty Assembly, Automotive, Construction, Glass Manufacturing, Metal Handling and Metal Stamping.
                        </p>
                    </div>


                    <div>
                        <div>
                        <img src="/images/st-learning/hand-protection/A8.png"  alt="raised diamond grip coating" />
                        </div>
                        <p>
                        <strong>5,000 – 5,999 GRAMS: TYPICAL USES</strong> <br />
                        Heavy-duty Assembly, Automotive, Construction, Glass Manufacturing, Metal Handling and Metal Stamping.
                        </p>
                    </div>

                    <div>
                        <div>
                        <img src="/images/st-learning/hand-protection/A9.png"  alt="honeycomb grip coating" />
                        </div>

                        <p>
                        <strong>6,000+ GRAMS: TYPICAL USES</strong> <br />
                        Heavy-duty Assembly, Automotive, Construction, Glass Manufacturing, Metal Handling and Metal Stamping.
                        </p>
                    </div>
                </VueSlickCarousel>

            </div>


            <p class="expert-link">
                <!-- <a href="https://www.amazon.com/stores/page/446A8CF3-5F34-46A9-A1CE-FD7714A7B14C?ingress=0&visitId=d30cc342-e3fc-4080-9d26-b31726265f6b&ref_=ast_bln">View all Hand Protection products ></a> -->
            </p>

            <div>
                <br>
                <br>
                <i>
                    CAUTION: This guide is provided as an aid in determining the general suitability of various products for use in cut protection applications. These recommendations are advisory only and the SUITABILITY OF THE PRODUCT FOR A SPECIFIC APPLICATION OR ENVIRONMENT MUST BE DETERMINED BY THE PURCHASER OR USER OF THE PRODUCT. This should be used as a guide only.
                </i>
            </div>

        </div>

    </div>
</template>

<script>
    import VueSlickCarousel from "vue-slick-carousel";
    import "vue-slick-carousel/dist/vue-slick-carousel.css";
    import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
    export default {
        data() {
            return {
            name: 'Vue.js',
            settings: {
                  "autoplay": false,
                  "focusOnSelect": true,
                  "infinite": false,
                  "pauseOnFocus": true,
                  "slidesToShow": 3,
                  "speed": 500,
                  "arrows":true,
                  responsive: [
                      {
                      breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                      },
                      {
                      breakpoint: 500,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                      }
                    ]
                }
            }
        },

        methods: {
            seamlessHover(event) {
                if (event) {
                    //Images
                    this.$refs['tech-img-seamless'].style="display: block;";
                    this.$refs['tech-img-poly'].style="display: none;";
                    this.$refs['tech-img-cut'].style="display: none;";

                    //Border
                    this.$refs['tech-th-seamless'].style="border-bottom: solid 3px #cd1b00;";
                    this.$refs['tech-th-poly'].style="border-bottom: solid 3px #fff;";
                    this.$refs['tech-th-cut'].style="border-bottom: solid 3px #fff;";

                    //text
                    this.$refs['tech-txt-seamless'].style="display: block;";
                    this.$refs['tech-txt-poly'].style="display: none;";
                    this.$refs['tech-txt-cut'].style="display: none;";
                }
            },
            polyHover(event) {
                if (event) {
                    //Images
                    this.$refs['tech-img-seamless'].style="display: none;";
                    this.$refs['tech-img-poly'].style="display: block;";
                    this.$refs['tech-img-cut'].style="display: none;";

                    //Border
                    this.$refs['tech-th-seamless'].style="border-bottom: solid 3px #fff;";
                    this.$refs['tech-th-poly'].style="border-bottom: solid 3px #cd1b00;";
                    this.$refs['tech-th-cut'].style="border-bottom: solid 3px #fff;";

                    //text
                    this.$refs['tech-txt-seamless'].style="display: none;";
                    this.$refs['tech-txt-poly'].style="display: block;";
                    this.$refs['tech-txt-cut'].style="display: none;";
                }
            },
            cutHover(event) {
                if (event) {
                    //Images
                    this.$refs['tech-img-seamless'].style="display: none;";
                    this.$refs['tech-img-poly'].style="display: none;";
                    this.$refs['tech-img-cut'].style="display: block;";

                    //Border
                    this.$refs['tech-th-seamless'].style="border-bottom: solid 3px #fff;";
                    this.$refs['tech-th-poly'].style="border-bottom: solid 3px #fff;";
                    this.$refs['tech-th-cut'].style="border-bottom: solid 3px #cd1b00;";

                    //text
                    this.$refs['tech-txt-seamless'].style="display: none;";
                    this.$refs['tech-txt-poly'].style="display: none;";
                    this.$refs['tech-txt-cut'].style="display: block;";
                }
            },
            showMobile(event) {
                if (event) {
                    this.$refs['mobileView'].style="display: block;";
                    this.$refs['readMore'].style="display: none;";
                    this.$refs['readLess'].style="display: block;";
                }
            },
            hideMobile(event) {
                if (event) {
                    this.$refs['mobileView'].style="display: none;";
                    this.$refs['readMore'].style="display: block;";
                    this.$refs['readLess'].style="display: none;";
                }
            },
            burgerClicked(event) {
                if (event) {
                    if (this.$refs['gloveDropdown'].style.display != "block") {
                        this.$refs['gloveDropdown'].style="display: block;";
                    } else {
                        this.$refs['gloveDropdown'].style="display: none;";
                    }
                }
            }
        },
        components: { VueSlickCarousel }
    }
</script>
